package ru.it_mozaika.sender.js.application.routes

import js.core.jso
import react.create
import react.router.RouteObject
import ru.it_mozaika.sender.js.application.frames.files.s3ListFrame

val s3FileRoute = jso<RouteObject> {
    path = "s3files"
    element = s3ListFrame.create()
}
